import { render, staticRenderFns } from "./groupParticipation.vue?vue&type=template&id=5642ee62&scoped=true"
import script from "./groupParticipation.vue?vue&type=script&lang=js"
export * from "./groupParticipation.vue?vue&type=script&lang=js"
import style0 from "./groupParticipation.vue?vue&type=style&index=0&id=5642ee62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5642ee62",
  null
  
)

export default component.exports